module.exports = __webpack_public_path__ + "1512e535e420ee8a905d8ad330c77819.svg";